<template>
  <lt-ui-form contendPadding="0px" style="border-width:0px;">
    <el-form ref="form" :model="form" label-width="60px">
      <el-row v-if="selectCellType == 'qrCode' || selectCellType == 'barCode'">
        <el-row>
          <el-col>
            <el-form-item label="文本">
              <el-input
                v-model="form.BarcodeText"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="自动填充">
              <el-checkbox v-model="form.ifFixText">自动填充</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="selectCellType == 'barCode'">
          <el-col>
            <el-form-item label="条码格式">
              <el-select v-model="form.barcodeType" style="width:218px">
                <el-option
                  v-for="item in barcodeTypeOption"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <el-form-item label="条码格式">
              <el-input v-model="form.barcodeType" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <el-row v-else>
        <el-row>
          <el-col>
            <el-form-item label="文本">
              <el-select
                v-model="form.Text"
                style="width:238px"
                v-if="selectCellType == 'fx'"
              >
                <el-option
                  v-for="item in variantOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-else
                v-model="form.Text"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="字体">
              <el-select v-model="form.font" style="width:238px">
                <el-option
                  v-for="item in fontFamily"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="字体大小" prop="fontSize">
              <el-input v-model="form.fontSize">
                <el-button
                  slot="prepend"
                  icon="icon icon-minus green"
                  @click="handleFontDesc"
                ></el-button>
                <el-button
                  slot="append"
                  icon="icon icon-plus green"
                  @click="handleFontIncrese"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="字体样式">
              <el-button
                size="mini"
                icon=" icon icon-bold "
                @click="handleSetFontWeight"
                title="加粗"
              ></el-button>
              <el-button
                size="mini"
                icon=" icon icon-italic "
                @click="handleSetItlic"
                title="倾斜"
              ></el-button>
              <el-button
                size="mini"
                icon=" icon icon-underline "
                @click="handleSetUnderLine"
                title="下滑线"
              ></el-button>
              <el-button
                size="mini"
                icon=" icon icon-arrow-up "
                @click="handleShowHor"
                title="垂直显示"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="段落">
              <el-button
                size="mini"
                icon="fa fa-align-left "
                @click="handleSetGraphLeft"
                title="左对齐"
              ></el-button>
              <el-button
                size="mini"
                class="fa fa-align-center"
                @click="handleSetGraphCenter"
                title="居中对齐"
              ></el-button>
              <el-button
                size="mini"
                icon="fa fa-align-right "
                @click="handleSetGraphRight"
                title="右对齐"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="对齐方式">
              <el-button
                size="mini"
                icon="iconfont ali-iconalign-top"
                @click="handleSetPositiLeft"
                title="顶"
              ></el-button>
              <el-button
                size="mini"
                class="iconfont ali-iconalign-middle"
                @click="handleSetPositiCenter"
                title="居中"
              ></el-button>
              <el-button
                size="mini"
                icon="iconfont ali-iconalign-bottom "
                @click="handleSetPositiBottom"
                title="底"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="文本位置">
              <el-select v-model="form.textPositi" style="width:238px">
                <el-option key="TTL" label="上左" value="TTL"></el-option>
                <el-option key="TTC" label="上中" value="TTC"></el-option>
                <el-option key="TTR" label="上右" value="TTR"></el-option>
                <el-option key="CTL" label="左" value="CTL"></el-option>
                <el-option key="CTC" label="中" value="CTC"></el-option>
                <el-option key="CTR" label="右" value="CTR"></el-option>
                <el-option key="BTL" label="下左" value="BTL"></el-option>
                <el-option key="BTC" label="下中" value="BTC"></el-option>
                <el-option key="BTR" label="下右" value="BTR"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="文本颜色">
              <el-color-picker
                v-model="form.textColor"
                size="mini"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="背景色">
              <el-color-picker
                v-model="form.textBGColor"
                size="mini"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="边框颜色">
              <el-color-picker
                v-model="form.textBorderColor"
                size="mini"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="自动换行">
              <el-checkbox v-model="form.textWordWrap">自动换行</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="透明度" prop="textOpacity">
              <el-input v-model="form.textOpacity">
                <el-button
                  slot="prepend"
                  icon="icon icon-minus green"
                  @click="handleTextOpacDesc"
                ></el-button>
                <el-button
                  slot="append"
                  icon="icon icon-plus green"
                  @click="handleTextOpacIncrese"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="内边距">
              <div style="height:25px">
                <label>全部</label>
                <el-input
                  v-model="form.textPadding"
                  style="margin-left:36px;width:200px;margin-top:-22px"
                >
                  <el-button
                    slot="prepend"
                    icon="icon icon-minus green"
                    @click="handleTextPadDesc"
                  ></el-button>
                  <el-button
                    slot="append"
                    icon="icon icon-plus green"
                    @click="handleTextPadIncrese"
                  ></el-button>
                </el-input>
              </div>
              <div style="height:25px">
                <label>左</label>
                <el-input
                  v-model="form.textPaddingL"
                  style="margin-left:22px;width:200px;margin-top:3px"
                >
                  <el-button
                    slot="prepend"
                    icon="icon icon-minus green"
                    @click="handleTextPadLDesc"
                  ></el-button>
                  <el-button
                    slot="append"
                    icon="icon icon-plus green"
                    @click="handleTextPadLIncrese"
                  ></el-button>
                </el-input>
              </div>
              <div style="height:25px">
                <label>右</label>
                <el-input
                  v-model="form.textPaddingR"
                  style="margin-left:22px;width:200px;margin-top:3px"
                >
                  <el-button
                    slot="prepend"
                    icon="icon icon-minus green"
                    @click="handleTextPadRDesc"
                  ></el-button>
                  <el-button
                    slot="append"
                    icon="icon icon-plus green"
                    @click="handleTextPadRIncrese"
                  ></el-button>
                </el-input>
              </div>
              <div style="height:25px">
                <label>上</label>
                <el-input
                  v-model="form.textPaddingT"
                  style="margin-left:22px;width:200px;margin-top:3px"
                >
                  <el-button
                    slot="prepend"
                    icon="icon icon-minus green"
                    @click="handleTextPadTDesc"
                  ></el-button>
                  <el-button
                    slot="append"
                    icon="icon icon-plus green"
                    @click="handleTextPadTIncrese"
                  ></el-button>
                </el-input>
              </div>
              <div style="height:25px">
                <label>下</label>
                <el-input
                  v-model="form.textPaddingB"
                  style="margin-left:22px;width:200px;margin-top:3px"
                >
                  <el-button
                    slot="prepend"
                    icon="icon icon-minus green"
                    @click="handleTextPadBDesc"
                  ></el-button>
                  <el-button
                    slot="append"
                    icon="icon icon-plus green"
                    @click="handleTextPadBIncrese"
                  ></el-button>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </lt-ui-form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default() {
        return null;
      },
    },
    ifChange: {
      type: Number,
      default: 0,
    },
    fontFamily: {
      type: Array,
      default() {
        return [
          {
            label: "宋体",
            value: "SimSun",
          },
          {
            label: "黑体",
            value: "SimHei",
          },
          {
            label: "微软雅黑",
            value: "Microsoft Yahei",
          },
          {
            label: "微软正黑",
            value: "Microsoft JhengHei",
          },
          {
            label: "楷体",
            value: "KaiTi",
          },
          {
            label: "標楷體",
            value: "DFKai-SB",
          },
          {
            label: "細明體",
            value: "MingLiU",
          },
          {
            label: "新細明體",
            value: "PMingLiU",
          },
          {
            label: "標楷體",
            value: "BiauKai",
          },
          {
            label: "新宋体",
            value: "NSimSun",
          },
          {
            label: "仿宋",
            value: "FangSong",
          },
          {
            label: "华文新魏",
            value: "STXinwei",
          },
          {
            label: "华文行楷",
            value: "STXingkai",
          },
          {
            label: "华文隶书",
            value: "STLiti",
          },
          {
            label: "华文琥珀",
            value: "STHupo",
          },
          {
            label: "华文彩云",
            value: "STCaiyun",
          },
          {
            label: "方正姚体",
            value: "FZYaoti",
          },
          {
            label: "方正舒体",
            value: "FZShuTi",
          },
          {
            label: "华文仿宋",
            value: "STFangsong",
          },
          {
            label: "华文中宋",
            value: "STZhongsong",
          },
          {
            label: "华文宋体",
            value: "STSong",
          },
          {
            label: "华文楷体",
            value: "STKaiti",
          },
          {
            label: "华文细黑",
            value: "STXihei",
          },
          {
            label: "华文黑体",
            value: "STHeiti",
          },
          {
            label: "隶书",
            value: "LiSu",
          },
          {
            label: "幼圆",
            value: "YouYuan",
          },
          {
            label: "楷体_GB2312",
            value: "KaiTi_GB2312",
          },
          {
            label: "仿宋_GB2312",
            value: "FangSong_GB2312",
          },
          {
            label: "PmingLiu",
            value: "PmingLiu",
          },
          {
            label: "Impact",
            value: "Impact",
          },
          {
            label: "Georgia",
            value: "Georgia",
          },
          {
            label: "Tahoma",
            value: "Tahoma",
          },
          {
            label: "Arial",
            value: "Arial",
          },
          {
            label: "Book Antiqua",
            value: "Book Antiqua",
          },
          {
            label: "Century Gothic",
            value: "Century Gothic",
          },
          {
            label: "Courier New",
            value: "Courier New",
          },
          {
            label: "Times New Roman",
            value: "Times New Roman",
          },
          {
            label: "Verdana",
            value: "Verdana",
          },
          {
            label: "Helvetica",
            value: "Helvetica",
          },
          {
            label: "Candara",
            value: "Candara",
          },
        ];
      },
    },
    BarCodeType: {
      //标签类型
      type: Array,
      default() {
        return [
          "CODE128",
          "CODE128 A",
          "CODE128 B",
          "CODE128 C",
          "EAN-13",
          "EAN-8",
          "EAN-5",
          "EAN-2",
          "UPC(A)",
          "UPC(E)",
          "CODE39",
          "ITF",
          "ITF-14",
          "MSI10",
          "MSI11",
          "MSI1010",
          "MSI1110",
          "Pharmacode",
          "Codabar",
        ];
      },
    },
    variant: {
      type: Array,
      default() {
        return ["变量1", "变量2", "变量3", "变量4"];
      },
    },
  },
  watch: {
    formData: function(newValue) {
      if (newValue != null && newValue != undefined) {
        if (newValue.target.cellType != undefined) {
          var state = newValue.parent.getView().getState(newValue.target);
          var style = state.style;
          // debugger;
          this.form.font = style.fontFamily; //字体
          this.form.fontSize = style.fontSize; //字体大小
          this.form.fontStyle = style.fontStyle; //是否加粗
          this.form.showHor =
            style.horizontal == 1 || style.horizontal == undefined
              ? true
              : false;
          this.getTextStyle(style.fontStyle);
          this.form.graphStyle = style.align; //段落对齐方式
          this.form.graphPositi = style.verticalAlign; //段落位置
          this._getTextPosition(style); //style.labelPosition; //文本相对位置
          this.form.textColor = style.fontColor; //文本颜色
          this.form.textBGColor = style.labelBackgroundColor; //背景色
          this.form.textBorderColor = style.labelBorderColor;
          this.form.textWordWrap = style.whiteSpace == "wrap" ? true : false; //文本自动换行
          this.form.textOpacity = style.opacity; //透明度
          this.form.textPadding =
            style.spacing == undefined ? 0 : style.spacing; //内边距
          this.form.textPaddingL =
            style.spacingLeft == undefined ? 0 : style.spacingLeft; //内边距左
          this.form.textPaddingR =
            style.spacingRight == undefined ? 0 : style.spacingRight; //内边距右
          this.form.textPaddingT =
            style.spacingTop == undefined ? 0 : style.spacingTop; //内边距顶
          this.form.textPaddingB =
            style.spacingBottom == undefined ? 0 : style.spacingBottom; //内边距底
          this.selectCellType = newValue.target.cellType; //当前选中的元素类型
          this.form.barcodeType = newValue.target.codeType;
          this.form.ifFixText = newValue.target.ifFixText;
          if (
            this.selectCellType != "qrCode" &&
            this.selectCellType != "barCode" &&
            this.selectCellType != "image"
          ) {
            this.form.Text = newValue.target.getValue(); //显示文本
          }
          this.form.cellType =
            newValue.target.cellType == undefined
              ? ""
              : newValue.target.cellType;
          //
        }
      }
    },
    form: {
      handler: function(newVal, oldVal) {
        var propertyData = {
          data: newVal,
          type: "Text",
        };
        // debugger
        if (this.selectCellType == "qrCode") {
          this.form.BarcodeText = "条码";
        }
        if (this.selectCellType == "barCode") {
          this.form.BarcodeText = "123456789";
        }
        if (this.ifChange) {
          return;
        }
        this.$emit("TextChange", propertyData);
      },
      deep: true,
    },
  },
  components: {},
  data() {
    return {
      form: {
        font: "Helvetica", //字体
        fontSize: 12, //字体大小
        showHor: false, //是否垂直显示文本
        fontStyle: 0, //文本显示样式
        graphStyle: "center", //段落对齐方式
        graphPositi: "center", //段落位置
        textPositi: "CTC", //文本相对位置
        textColor: "#000000", //文本颜色
        textBGColor: "#FFFFFF", //背景色
        textBorderColor: "#000000", //边框色
        textWordWrap: true, //文本自动换行
        textOpacity: 100, //透明度
        textPadding: 0, //内边距
        textPaddingL: 0, //内边距左
        textPaddingR: 0, //内边距右
        textPaddingT: 0, //内边距顶
        textPaddingB: 0, //内边距底
        textFix: false,
        Text: "", //显示文本
        BarcodeText: "", //文本(条码)
        ifFixText: true, //条码内容是否自动生成
        barcodeType: "CODE128", //条码格式
        cellType: "", //元素类别
      },
      showEditStyle: false,
      // fontFamily: this.fontFamily,
      fontWeight: false, //是否加粗
      Itlic: false, //是否倾斜
      underLine: false, //是否加下划线
      ifShowText: false, //是否显示文本值
      barcodeTypeOption: this.BarCodeType, //一维码条码格式
      selectCellType: "", //当前选择的条码类型
      variantOption: [], //变量
    };
  },
  methods: {
    _getTextPosition(style) {
      //根据样式设置文本相对位置
      if (style.verticalLabelPosition == "top") {
        if (style.labelPosition == "left") {
          this.form.textPositi = "TTL";
        } else if (style.labelPosition == "right") {
          this.form.textPositi = "TTR";
        } else {
          this.form.textPositi = "TTC";
        }
      }
      if (style.verticalLabelPosition == "middle") {
        if (style.labelPosition == "left") {
          this.form.textPositi = "CTL";
        } else if (style.labelPosition == "right") {
          this.form.textPositi = "CTR";
        } else {
          this.form.textPositi = "CTC";
        }
      }
      if (style.verticalLabelPosition == "bottom") {
        if (style.labelPosition == "left") {
          this.form.textPositi = "BTL";
        } else if (style.labelPosition == "right") {
          this.form.textPositi = "BTR";
        } else {
          this.form.textPositi = "BTC";
        }
      }
      // debugger;
    },
    setStatusByFontStyle() {
      var temp =
        Number(this.underLine).toString() +
        Number(this.Itlic).toString() +
        Number(this.fontWeight).toString();
      var targetStyle = parseInt(temp, 2);
      this.form.fontStyle = targetStyle;
    },
    getTextStyle(number) {
      switch (number) {
        case 0: {
          this.fontWeight = false;
          this.Itlic = false;
          this.underLine = false;
          break;
        }
        case 1: {
          this.underLine = false;
          this.Itlic = false;
          this.fontWeight = true;
          break;
        }
        case 2: {
          this.underLine = false;
          this.Itlic = true;
          this.fontWeight = false;
          break;
        }
        case 4: {
          this.underLine = true;
          this.Itlic = false;
          this.fontWeight = false;
          break;
        }
        case 3: {
          this.underLine = false;
          this.Itlic = true;
          this.fontWeight = true;
          break;
        }
        case 5: {
          this.underLine = true;
          this.Itlic = false;
          this.fontWeight = true;
          break;
        }
        case 6: {
          this.underLine = true;
          this.Itlic = true;
          this.fontWeight = false;
          break;
        }
        case 7: {
          this.underLine = true;
          this.Itlic = true;
          this.fontWeight = true;
          break;
        }
      }
    },
    getFormData() {
      //返回页面数据
      return this.form;
    },
    handleFontDesc() {
      //字体大小
      if (this.form.fontSize > 6) {
        this.form.fontSize--;
      }
    },
    handleFontIncrese() {
      //字体大小
      this.form.fontSize++;
    },
    handleSetFontWeight() {
      if (this.fontWeight == false) {
        this.fontWeight = true;
      } else {
        this.fontWeight = false;
      }
      this.setStatusByFontStyle();
    },
    handleSetItlic() {
      if (this.Itlic) {
        this.Itlic = false;
      } else {
        this.Itlic = true;
      }
      this.setStatusByFontStyle();
    },
    handleSetUnderLine() {
      if (this.underLine) {
        this.underLine = false;
      } else {
        this.underLine = true;
      }
      this.setStatusByFontStyle();
    },
    handleShowHor() {
      if (this.form.showHor) {
        this.form.showHor = false;
      } else {
        this.form.showHor = true;
      }
    },
    _setLabelHeight() {
      // var item = $(this.$el).find("div.el-row");
      // var temp = this.$refs.form
      //el-form-item__label
      // debugger;
    },
    handleSetGraphLeft() {
      this.form.graphStyle = "left";
    },
    handleSetGraphCenter() {
      this.form.graphStyle = "center";
    },
    handleSetGraphRight() {
      this.form.graphStyle = "right";
    },
    handleSetPositiLeft() {
      this.form.graphPositi = "left";
    },
    handleSetPositiCenter() {
      this.form.graphPositi = "middle";
    },
    handleSetPositiBottom() {
      this.form.graphPositi = "bottom";
    },
    handleTextOpacDesc() {
      if (this.form.textOpacity > 1) {
        this.form.textOpacity--;
      }
    },
    handleTextOpacIncrese() {
      if (this.form.textOpacity < 100) {
        this.form.textOpacity++;
      }
    },
    handleTextPadDesc() {
      if (this.form.textPadding > 0) {
        this.form.textPadding--;
      }
    },
    handleTextPadIncrese() {
      this.form.textPadding++;
    },
    handleTextPadLDesc() {
      if (this.form.textPaddingL > 0) {
        this.form.textPaddingL--;
      }
    },
    handleTextPadLIncrese() {
      this.form.textPaddingL++;
    },
    handleTextPadRDesc() {
      if (this.form.textPaddingR > 0) {
        this.form.textPaddingR--;
      }
    },
    handleTextPadRIncrese() {
      this.form.textPaddingR++;
    },
    handleTextPadTDesc() {
      if (this.form.textPaddingT > 0) {
        this.form.textPaddingT--;
      }
    },
    handleTextPadTIncrese() {
      this.form.textPaddingT++;
    },
    handleTextPadBDesc() {
      if (this.form.textPaddingB > 0) {
        this.form.textPaddingB--;
      }
    },
    handleTextPadBIncrese() {
      this.form.textPaddingB++;
    },
    getVarOption() {
      var temp = this.variant;
      for (var i = 0; i < temp.length; i++) {
        var item = {
          value: "[" + temp[i] + "]",
          label: "[" + temp[i] + "]",
        };
        var copy = {};
        $.extend(true, copy, item);
        this.variantOption.push(copy);
      }
    },
  },
  beforeMount() {
    this.getVarOption();
  },
  mounted() {
    //this._setLabelHeight();
  },
};
</script>

<style scoped>
.ltui-panel.ltui-form >>> .ltui-panel__content {
  overflow: hidden !important;
}
</style>
